module.exports = __webpack_public_path__ + "static/media/basic_thumb.4e2f95c3.jpg";